module.exports = __webpack_public_path__ + "img/angry2.ea3233b0.png";